import React from 'react';
import PortalPage from '../components/PortalPage';
import ChangelogTab from './dashboard/ChangelogTab';

// /releases — mounted inside the portal shell by App.js, like every other page.
export default function ReleasesPage() {
  return (
    <PortalPage
      title="Releases"
      lede="What changed on the platform, newest first — taken from the commit history. Filter by kind; open an entry for the full note."
    >
      <ChangelogTab />
    </PortalPage>
  );
}
